export default __webpack_public_path__ + "static/media/notice.d1bf584f.png";